/**
 * Created by hao.cheng on 2017/4/13.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import { withRouter } from 'react-router-dom';
import { menus } from './menus';
import SiderMenu from './SiderMenu';
import Logo from "../../style/imgs/zfq_logo.jpg";
import { handleExportParams } from '../../utils';
// import Logo from "../../style/imgs/zfq_logo_2.png";

const { Sider } = Layout;

class SiderCustom extends Component {
    state = {
        collapsed: false,
        mode: 'inline',
        openKey: '',
        selectedKey: '',
        firstHide: true,        // 点击收缩菜单，第一次隐藏展开子菜单，openMenu时恢复
        logoAnimate: 'bounceInUp'
    };
    componentDidMount() {
        this.setMenuOpen(this.props);
        this.filterAuthMenu(this.props); //设置菜单
        this.onCollapse(this.props.collapsed);
    }
    componentWillReceiveProps(nextProps) {
        this.onCollapse(nextProps.collapsed);
        this.setMenuOpen(nextProps)
    }
    filterAuthMenu(props) {                                   //---根据身份过滤Auth的菜单
        var menusAuth = props.config.auth.menusAuth || '';
        var copyMenus = JSON.parse(JSON.stringify(menus))
        var newMenu = [];
        copyMenus.forEach(e => {
            if (e.sub) {
                if (handleExportParams().merchantId > 0) {
                    if (e.isJr) {
                        if (!(handleExportParams().isJr === 1)) {
                            return
                        }
                    }
                    if (e.isDevice) {
                        if (!(handleExportParams().isDevice === 1)) {
                            return
                        }
                    }
                }
                let subItem = []
                e.sub.forEach(ee => {
                    if (!ee.authkey || ee.authkey.indexOf(menusAuth) > -1) {
                        if (handleExportParams().merchantId > 0) {
                            if (ee.isJr) {
                                if (handleExportParams().isJr === 1) {
                                    subItem.push(ee)
                                }
                                return
                            }
                            if (ee.isDevice) {
                                if (handleExportParams().isDevice === 1) {
                                    subItem.push(ee)
                                }
                                return
                            }
                        }
                        subItem.push(ee)
                    }
                })
                if (subItem.length > 0) {
                    e.sub = subItem
                    newMenu.push(e)
                }
            } else if (!e.authkey || e.authkey.indexOf(menusAuth) > -1) {
                if (handleExportParams().merchantId > 0) {
                    if (e.isJr) {
                        if (handleExportParams().isJr === 1) {
                            newMenu.push(e)
                        }
                        return
                    }
                    if (e.isDevice) {
                        if (handleExportParams().isDevice === 1) {
                            newMenu.push(e)
                        }
                        return
                    }
                }
                newMenu.push(e)
            }
        })
        this.setState({
            menuList: newMenu
        }, () => {
            this.filterAuthCodeMenu()
        })
    }

    filterAuthCodeMenu() {      //第二次过滤, 根据权限点过滤菜单
        let {
            config: { auth }
        } = this.props,
            { menuList } = this.state,
            newMenu = []

        if (!auth.isAdmin) {  //如果不是管理员 才过滤菜单

            menuList.forEach(e => {
                if (e.sub) {
                    let subItem = []
                    e.sub.forEach(ee => {
                        if (auth.authKeyList.indexOf(ee.authKeyCode) > -1) {
                            subItem.push(ee)
                        }
                    })
                    if (subItem.length > 0) {
                        e.sub = subItem
                        newMenu.push(e)
                    }
                } else if (auth.authKeyList.indexOf(e.authKeyCode) > -1) {
                    newMenu.push(e)
                }
            })
            this.setState({
                menuList: newMenu
            })
        }
    }

    setMenuOpen = props => {
        const { pathname } = props.location;
        this.setState({
            openKey: pathname.substr(0, pathname.lastIndexOf('/')),
            selectedKey: pathname
        });
    };
    onCollapse = (collapsed) => {
        this.setState({
            collapsed,
            firstHide: collapsed,
            mode: collapsed ? 'vertical' : 'inline',
        });
    };
    menuClick = e => {
        this.setState({
            selectedKey: e.key
        });
        const { popoverHide } = this.props;     // 响应式布局控制小屏幕点击菜单时隐藏菜单操作
        popoverHide && popoverHide();
    };
    openMenu = v => {
        this.setState({
            openKey: v[v.length - 1],
            firstHide: false,
        })
    };

    render() {
        return (
            <Sider
                trigger={null}
                breakpoint="lg"
                collapsed={this.props.collapsed}
                style={{ overflowY: 'auto' }}
            >
                <div className={"logo animated " + this.state.logoAnimate}
                    onClick={() => {
                        let arr = ['tada', 'swing', 'bouce', 'flash', 'pulse', 'rubbeBand', 'jello']
                        let index = Math.floor(Math.random() * arr.length)

                        if (this.propIndex === index) {
                            index = index - 1 < 0 ? index + 1 : index - 1
                        }
                        this.setState({
                            logoAnimate: arr[index]
                        }, () => { this.propIndex = index })
                    }}
                >
                    <img src={Logo} alt="" />
                    {this.state.collapsed ? null : <span style={{
                        fontSize: "22px"
                    }}
                                                   >中和智家</span>}
                    {/* {this.state.collapsed ? null : <span style={{
                        fontSize: "22px"
                    }}
                    >租赁系统</span>} */}
                </div>
                {
                    this.state.menuList
                        ? <SiderMenu
                            menus={this.state.menuList}
                            onClick={this.menuClick}
                            theme="dark"
                            mode="inline"
                            selectedKeys={[this.state.selectedKey]}
                            openKeys={this.state.firstHide ? null : [this.state.openKey]}
                            onOpenChange={this.openMenu}
                          />
                        : null
                }
            </Sider>
        )
    }
}
const mapStateToProps = state => {
    return state
};

export default withRouter(connect(mapStateToProps)(SiderCustom));


// WEBPACK FOOTER //
// ./src/layout/slideMenu/SiderCustom.jsx